import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=0487c0fa&scoped=true"
import script from "./Talent.vue?vue&type=script&lang=js"
export * from "./Talent.vue?vue&type=script&lang=js"
import style0 from "./Talent.vue?vue&type=style&index=0&id=0487c0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0487c0fa",
  null
  
)

export default component.exports